import Message from '../message/Message';
import PropTypes from 'prop-types';
import React from 'react';
import {generateAppPath} from 'epic-common/src/route';

const Error500 = function Error500({staticContext}) {
    if (staticContext) {
        staticContext.status = 500;
    }
    const homeLink = generateAppPath('/home');
    return (
        <div className="error500 errorPages">
            <div className="content">
                <div className="errorHeader">
                    <h1><Message code="epic.spyjinx.500.title" /></h1>
                    <h3><Message code="epic.spyjinx.500.subtitle" /></h3>
                    <div className="error-detail">
                        <p><Message code="epic.spyjinx.500.msg1" /></p>
                        <p><Message code="epic.spyjinx.500.msg2" /></p>
                    </div>
                    <a className="btn btn-custom buy-now-btn" href={homeLink}>
                        <Message code="epic.spyjinx.common.home_page" />
                    </a>
                </div>
            </div>
        </div>
    );
};

Error500.propTypes = {
    staticContext: PropTypes.object
};

export default Error500;

